import React, { useCallback, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { v4 as uuidv4 } from "uuid"
import { MdClose } from "react-icons/md"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { isStockLimited, ObjectValues } from "utils"
import { IconButton, Input } from "components"
import { addOrderItem, hideFoodSearchBar, updateOrderItem } from "@redux"
import classes from "./FoodsSearch.module.scss"

const FoodsSearch = props => {
  const { setSearchedFoods } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const foodTaxesMap =
    useSelector(state => state.foodTaxesMap)

  const foodsMap = useSelector(state => state.foods)

  const orderItems = useSelector(state => state.order.items)

  const [inputValue, setInputValue] = useState("")

  const timeout = useRef()
  const ref = useRef(null)

  const handleCloseSearchBar = () => {
    dispatch(hideFoodSearchBar())
  }

  const handleAutoFocusSearchbar =
    useCallback(() => {
      const isModalOpen =
        !!document.getElementById("modal")

      const isPinModalOpen =
        !!document.getElementById("pin-modal")

      if (isModalOpen) return

      if (isPinModalOpen) return

      ref.current &&
        ref.current.focus()
    }, [])

  const createOrderItem = (food, option, newQuantity) => {
    const orderItemId = uuidv4()

    const isSimple = food.options.length === 1

    const foodTaxItems = []

    food.taxItemIds.forEach(foodTaxItemId => {
      const taxItem =
        foodTaxesMap[foodTaxItemId]

      if (!taxItem) return

      foodTaxItems.push(taxItem)
    })

    const newOrderItem = {
      orderItemId,
      foodId: food._id,
      optionId: option._id,
      code: food.code,
      isAvailable: true,
      isSimple,
      unit: food.unit,
      categoryIds: food.categoryIds,
      taxInclusive: food.taxInclusive,
      taxItems: foodTaxItems,
      foodImageCover: food.imageCover,
      quantity: newQuantity,
      specificationItems: [],
      foodName: food.name,
      optionName: option.name,
      salePrice: option.salePrice,
      stockManagement: option.stockManagement,
      availableQuantity: option.availableQuantity,
      systemDiscount: 0
    }

    return newOrderItem
  }

  const addFoodToCart = (barcode) => {
    clearTimeout(timeout.current)

    const foods = ObjectValues(foodsMap)

    const food =
      foods.find(food =>
        food.options.some(option =>
          option.barCode === barcode
        )
      )

    if (!food) {
      setInputValue("")

      setSearchedFoods(null)

      toast.error("کالایی_یافت_نشد")

      return
    }

    const option =
      food.options.find(option =>
        option.barCode === barcode
      )

    const targetOrderItem =
      orderItems.find(orderItem =>
        orderItem.optionId === option._id
      )

    const targetOrderItemQuantity =
      targetOrderItem?.quantity || 0

    const newQuantity =
      Number(
        Number(targetOrderItemQuantity + 1).toFixed(2)
      )

    const newOrderItem =
      createOrderItem(
        food,
        option,
        newQuantity
      )

    const increasedQuantity = 1

    const limitedStock =
      isStockLimited(newOrderItem, increasedQuantity)

    if (limitedStock) return

    !!targetOrderItem
      ?
      dispatch(
        updateOrderItem(
          newOrderItem,
          targetOrderItem.orderItemId
        )
      )
      :
      dispatch(
        addOrderItem(newOrderItem)
      )

    setInputValue("")

    setSearchedFoods(null)
  }

  const handleEnter = (e) => {
    if (e.key !== "Enter") return

    if (!inputValue.trim()) return

    addFoodToCart(inputValue)
  }

  const searchFoods = async (search) => {
    const foods = ObjectValues(foodsMap)

    const results = []

    foods.forEach(food => {
      const nameCheck =
        food.name.toLowerCase().includes(search.toLowerCase())

      const codeCheck =
        food.code === Number(search)

      const barcodeCheck =
        food.options.some(option =>
          option.barCode?.startsWith(search)
        )

      const exists =
        nameCheck || codeCheck || barcodeCheck


      if (exists) results.push(food)
    })

    setSearchedFoods(results)
  }

  const handleChange = (e) => {
    const text = e.target.value

    setInputValue(text)

    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(() => {
        searchFoods(text.trim())
      }, 700)
  }

  useEffect(() => {
    ref.current.focus()

    window.addEventListener("keydown", handleAutoFocusSearchbar)

    return () => {
      clearTimeout(timeout.current)

      setSearchedFoods(null)

      window.removeEventListener("keydown", handleAutoFocusSearchbar)
    }
  }, [])

  const dir = i18n.dir(i18n.language)

  const isLtr = dir === "ltr"

  return (
    <div className={classes["container"]}>
      <div className={classes["input-container"]}>
        <Input
          ref={ref}
          className={clsx(classes["input"], isLtr && classes["input-ltr"])}
          value={inputValue}
          placeholder={t("جست_و_جو_کالا_با_اسم_و_کد")}
          onChange={handleChange}
          onKeyDown={handleEnter}
        />
      </div>

      <IconButton
        icon={MdClose}
        color="white"
        className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
        size={30}
        onClick={handleCloseSearchBar}
      />
    </div>
  )
}

export default FoodsSearch